import { render, staticRenderFns } from "./personalContent.vue?vue&type=template&id=71174a26"
import script from "./personalContent.vue?vue&type=script&lang=js"
export * from "./personalContent.vue?vue&type=script&lang=js"
import style0 from "./personalContent.vue?vue&type=style&index=0&id=71174a26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports